export default __webpack_public_path__ + "static/media/IconDesc_Rubber.256.52229db0.png";